import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { Button, Form, Input } from 'antd'
import { observer } from 'mobx-react'
import { SafetyOutlined } from '@ant-design/icons'
import { AppStore } from 'src/pc/store/AppStore'

type PhoneCaptchaInputProps = {
  GetPhoneCaptcha: () => void
}

const PhoneCaptchaInput: FunctionComponent<PhoneCaptchaInputProps> = ({ GetPhoneCaptcha }) => {
  return (
    <Form.Item name="Code" rules={[{ required: true, message: '请输入验证码' }]}>
      <Input
        maxLength={4}
        placeholder="请输入验证码"
        prefix={<SafetyOutlined />}
        suffix={
          <StyledCaptchaButton disabled={AppStore.PhoneCaptchaLoading} onClick={GetPhoneCaptcha}>
            {AppStore.PhoneCaptchaText}
          </StyledCaptchaButton>
        }
      />
    </Form.Item>
  )
}

export default observer(PhoneCaptchaInput)

const StyledCaptchaButton = styled(Button)`
  border: none;
  &.ant-btn:disabled {
    background: transparent !important;
    color: #757575 !important;
  }
`
